import { GET_ALL_PESQUISAS_SATISFACAO, GET_ALL_TAGS } from './mutation-types'

export default {
  [GET_ALL_PESQUISAS_SATISFACAO]: (state, pesquisasSatisfacao) => {
    state.pesquisasSatisfacao = pesquisasSatisfacao
  },
  [GET_ALL_TAGS]: (state, tags) => {
    state.tags = tags
  },
}
